import React, { useState } from 'react'
import ActionDialog from '../action-dialog'
import i18n from '../../../assets/i18n';
import { importCsvCandidates } from '../../../api'
import { useAppContext } from '../../../context/appContext'
import { ALERT_LEVEL } from '../../../config/constants'
import * as S from './styled'

const ModalImportEvaluativeTestsCandidates = ({ evaluativeConfigId, isModalOpen, handleClose, form, uploadResult = {} }) => {
  const { createAlert } = useAppContext();

  const {module} = useAppContext();

  const numTotal = (uploadResult?.total || 0).toString();
  const numProcessed = (uploadResult?.processed || 0).toString();
  const [isLoading, setIsLoading] = useState(false);

  const handleSendClick = async (e) => {
    e.preventDefault();
    if(isLoading) {
      return;
    }

    setIsLoading(true);

    // Si la petición falla se quita el spinner y el modal sigue abierto con la alerta de error
    let response = null;
    try {
      response = await importCandidates();
    } catch (error) {
      response = null;
    } finally {
      setIsLoading(false);
    }
    if (response && response.success) {
      const text = i18n.evaluativeTests.csvUpload.candidatesImported
        .replace("%ok%", response.imported)
        .replace("%total%", response.total);

      // Primero se cierra el modal y después sale la alerta
      handleClose && handleClose();
      createAlert(text, ALERT_LEVEL.SUCCESS, 5000);
    } else {
      createAlert(i18n.evaluativeTests.csvUpload.candidatesNotifiedError, ALERT_LEVEL.ERROR, 5000);
    }
  }

  const importCandidates = async function() {
    return await importCsvCandidates(evaluativeConfigId, module, form);
  }

  return (
    <ActionDialog
      open={isModalOpen}
      title={i18n.evaluativeTests.csvUpload.modalCheckCandidates
        .replace('%ok%', numProcessed)
        .replace('%total%', numTotal)}
      onClose={handleClose}
      onConfirm={handleSendClick}
      cancelLabel={i18n.modalGeneric.cancel}
      confirmLabel={i18n.modalGeneric.send}
      isPending={isLoading}
    >
      <S.Text>{i18n.evaluativeTests.csvUpload.modalImportCandidates}</S.Text>
    </ActionDialog>
  )
}

export default ModalImportEvaluativeTestsCandidates;
